export enum Tab {
    Profile = 'profile',
    News = 'news',
    ConfigureInformation = 'configure_information',
    SimpleDropdowns = 'simple_dropdowns',
    ComplexDropdowns = 'complex_dropdowns',
    ImpersonateUser = 'impersonate_user',
    ImpersonateProfile = 'profile',
    ImpersonateCases = 'my_cases'
}
